import { Injectable } from '@angular/core';
import { NewsfeedApiService } from '@epicuro-next/data/engagement/engagement-api';
import { NewsfeedType } from '@epicuro-next/data/engagement/engagement-models';
import { MessageType, showSnackBarMessage } from '@epicuro-next/state/snackbar';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import * as actions from '../actions';

const FEED_DELETE_FAILED_MESSAGES: {
  [key in NewsfeedType]: string;
} = {
  [NewsfeedType.Spotlight]: $localize`:@@NewsFeedDeleteFailed:Failed to delete from Spotlight.`,
  [NewsfeedType.WelcomePromotion]: $localize`:@@NewsFeedModalDeleteFailed:Failed to delete from Modal Promotion.`,
  [NewsfeedType.LandingPage]: $localize`:@@NewsFeedLandingPageDeleteFailed:Failed to delete from Landing Page Promotion.`,
};

const FEED_DELETE_SUCCESS_MESSAGES: {
  [key in NewsfeedType]: string;
} = {
  [NewsfeedType.Spotlight]: $localize`:@@NewsFeedDeleteSuccess:Item deleted from Spotlight.`,
  [NewsfeedType.WelcomePromotion]: $localize`:@@NewsFeedModalDeleteSuccess:Item deleted from Modal Promotion.`,
  [NewsfeedType.LandingPage]: $localize`:@@NewsFeedLandingPageDeleteSuccess:Item deleted from Landing Page Promotion.`,
};

/** News feed delete effects */
@Injectable()
export class DeleteEffects {
  /** Delete article action effect */
  public deleteArticle$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.deleteArticle),
      switchMap((action) => {
        return this.feedService.delete(action.feedId).pipe(
          map(() =>
            actions.deleteArticleSuccess({
              feedId: action.feedId,
              referenceId: action.referenceId,
              referenceType: action.referenceType,
              newsfeedType: action.newsfeedType,
            }),
          ),
          catchError(() =>
            of(
              actions.deleteArticleFail({
                newsfeedType: action.newsfeedType,
              }),
            ),
          ),
        );
      }),
    ),
  );

  public showSuccessMessage$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.deleteArticleSuccess),
      map(({ newsfeedType }) =>
        showSnackBarMessage({
          message: FEED_DELETE_SUCCESS_MESSAGES[newsfeedType],
          messageType: MessageType.SUCCESS,
        }),
      ),
    ),
  );

  public showFailedMessage$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.deleteArticleFail),
      map(({ newsfeedType }) =>
        showSnackBarMessage({
          message: FEED_DELETE_FAILED_MESSAGES[newsfeedType],
          messageType: MessageType.DANGER,
        }),
      ),
    ),
  );

  /** Dependencies */
  constructor(
    private actions$: Actions,
    private feedService: NewsfeedApiService,
  ) {}
}
